import { render, staticRenderFns } from "./pattern-fix-with-ai-btn.vue?vue&type=template&id=6ba2a4a8&"
import script from "./pattern-fix-with-ai-btn.vue?vue&type=script&lang=js&"
export * from "./pattern-fix-with-ai-btn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports